import { createRouter, createWebHistory } from 'vue-router';
import { Auth } from 'aws-amplify';
import NewPage from '@/components/NewPage.vue';
import AppLayout from '@/components/AppLayout.vue';
import MeowGPT from '@/components/MeowGPT.vue'
import FinancialDashboard from '@/components/FinancialDashboard.vue'
import FinancialCalendar from '@/components/FinancialCalendar.vue'
import RiskyGram from '@/components/RiskyGram.vue'
import LandingPage from '@/components/LandingPage.vue'
import PayoffDiagram from '@/components/framework/8-wealth/PayOffDiagram.vue'
import FrameworkDashboard from '@/components/framework/0-framework/FrameworkDashboard.vue'
import RiskManagement from '@/components/framework/1-risk/RiskManagementFramework.vue'
import Insurance from '@/components/framework/2-insure/InsuranceFramework.vue'
import Save from '@/components/framework/3-save/SaveFramework.vue'
import KYC from '@/components/framework/4-kyc/KYCFramework.vue'
import Yield from '@/components/framework/5-yield/YieldFramework.vue'
import Planning from '@/components/framework/6-planning/PlanningFramework.vue'
import AssetAllocation from '@/components/framework/7-assets/AssetAllocationFramework.vue'
import WealthManagement from '@/components/framework/8-wealth/WealthManagementFramework.vue'
import Strategies from '@/components/framework/9-strategy/StrategiesFramework.vue'
import Postit from '@/components/PostitNotes.vue'
import Test from '@/components/TestingThings.vue'
import Options from '@/components/OptionStrategies.vue'
import UserGreeting from '@/components/UserGreeting.vue'
import FinancialAssets from '@/components/FinancialAssets.vue'
import FinancialBudget from '@/components/FinancialBudget.vue'
import UserProfile from '@/components/UserProfile.vue'
import onboarding from '@/components/onboarding/13-OnboardingFinal.vue'
import insurancepremiums from '@/components/framework/2-insure/InsurancePremiums.vue'
import petinsurance from '@/components/framework/2-insure/PetInsurance.vue'
import investorprotections from '@/components/framework/2-insure/InvestorProtections.vue'
import yields from '@/components/framework/5-yield/YieldChasing.vue'
import compoundinterest from '@/components/framework/3-save/CompoundInterestCalculator.vue'
import coolingoff from '@/components/framework/3-save/CoolingOffPeriod.vue'
import riskintro from '@/components/framework/1-risk/RiskManagementIntro.vue'
import CreditEstimator from '@/components/framework/5-yield/CreditEstimator.vue'
import CreditExplainer from '@/components/framework/5-yield/CreditExplainer.vue'
import CreditScoreCalculator from '@/components/framework/5-yield/CreditScoreCalculator.vue'
import CreditLoanOfficer from '@/components/gamification/CreditLoanOfficer.vue'
import GoalSettingInput from '@/components/framework/6-planning/GoalSettingInput.vue'
import IncomeTaxCalculator from '@/components/framework/3-save/IncomeTaxCalculator.vue'
import GoalsObjectives from '@/components/framework/6-planning/GoalsObjectives.vue'
import HomeBuyerTool from '@/components/framework/7-assets/HomeBuyerTool.vue'
import StockLogoGame from '@/components/gamification/StockLogoGame.vue'
import TaxProvinces from '@/components/framework/3-save/TaxProvinces.vue'
import Framework from '@/components/framework/0-framework/FrameworkTools.vue'
import LazyPortfolio from '@/components/framework/8-wealth/LazyPortfolios.vue'
import TradingArt from '@/components/framework/8-wealth/TradingArt.vue'
import GroupRRSP from '@/components/framework/3-save/GroupRRSP.vue'
import Markets from '@/components/framework/stockcharts/MarketsOverview.vue'
import Personal from '@/components/PersonalAssets.vue'
import TrustedContact from '@/components/TrustedContact.vue'
import IncomeTaxes from '@/components/framework/3-save/IncomeTaxCalculator.vue'
import ComprehensiveRisk from '@/components/framework/1-risk/RiskComprehensive.vue'
import ApplyingRisk from '@/components/framework/1-risk/RiskApplying.vue'
import AML from '@/components/framework/4-kyc/KYCAML.vue'
import New from '@/components/NewTest.vue'
import KYCIntro from '@/components/framework/4-kyc/KYCIntro.vue' 
import ContributionRoom from '@/components/framework/3-save/ContributionRoom.vue'
import BudgetComingSoon from '@/components/framework/3-save/BudgetComingSoon.vue'
import Beta from '@/components/framework/8-wealth/BetaPortfolioCalculator.vue'
import Alpha from '@/components/framework/8-wealth/AlphaCalculator.vue'
import FindingAlpha from '@/components/framework/8-wealth/FindingAlpha.vue'
import TipCalculator from '@/components/framework/3-save/TipCalculator.vue'
import EconomicCalendar from '@/components/framework/5-yield/EconomicCalendar.vue'
import FinancialTracker from '@/components/FinancialTracker.vue'
import JobComparison from '@/components/framework/9-strategy/JobOfferComparison.vue'
import HomeBuyingTool from '@/components/framework/9-strategy/HomeBuyingToolNoAPI.vue'
import CanadianInvesting from '@/components/framework/7-assets/CanadianBias.vue'
import CADHeatMap from '@/components/framework/8-wealth/CADHeatmap.vue'
import USHeatMap from '@/components/framework/8-wealth/USHeatMap.vue'
import NetWorth from '@/components/NetWorth.vue'
import Holdings from '@/components/FinancialHoldings.vue'
import TradeJournal from '@/components/TradeJournal.vue'
import FinancialDiary from '@/components/FinancialDiary.vue'
import SubscriptionTracker from '@/components/SubscriptionTracker.vue'
import FinancialGoals from '@/components/framework/6-planning/FinancialGoals.vue'
import DivTracker from '@/components/DividendTracker.vue'
import UnclaimedProperty from '@/components/framework/7-assets/UnclaimedProperty.vue'
import InvestmentAccounts from '@/components/framework/3-save/InvestmentAccounts.vue'
import CreditCardsYield from '@/components/framework/5-yield/CreditCards.vue'
import EstatePlanning from '@/components/framework/6-planning/EstatePlanning.vue'
import ResetPassword from '@/components/ResetPassword.vue'
import Norbert from '@/components/framework/7-assets/NorbertsGambit.vue'
import Zakat from '@/components/framework/6-planning/ZakatCalculator.vue'
import GamesMenu from '@/components/gamification/GamesSavingsMenu.vue'
import QuizTemplate from '@/components/gamification/QuizzesTemplate.vue'
import FillBlank from '@/components/gamification/FillintheBlankTemplate.vue'
import Matching from '@/components/gamification/MatchingGameTemplate.vue'
import Scenario from '@/components/gamification/ScenarioGame.vue'
import MatchBasics1 from '@/components/gamification/match/MatchBasics1.vue'
import MatchBasics2 from '@/components/gamification/match/MatchBasics2.vue'
import MatchBasics3 from '@/components/gamification/match/MatchBasics3.vue'
import MatchBasics4 from '@/components/gamification/match/MatchBasics4.vue'
import MatchBasics5 from '@/components/gamification/match/MatchBasics5.vue'
import MatchBasics6 from '@/components/gamification/match/MatchBasics6.vue'
import MatchBasics7 from '@/components/gamification/match/MatchBasics7.vue'
import MatchBasics8 from '@/components/gamification/match/MatchBasics8.vue'
import MatchBasics9 from '@/components/gamification/match/MatchBasics9.vue'
import MatchBasics10 from '@/components/gamification/match/MatchBasics10.vue'
import QuizBasics1 from '@/components/gamification/quiz/QuizBasics1.vue'
import QuizBasics2 from '@/components/gamification/quiz/QuizBasics2.vue'
import QuizBasics3 from '@/components/gamification/quiz/QuizBasics3.vue'
import QuizBasics4 from '@/components/gamification/quiz/QuizBasics4.vue'
import QuizBasics5 from '@/components/gamification/quiz/QuizBasics5.vue'
import QuizBasics6 from '@/components/gamification/quiz/QuizBasics6.vue'
import QuizBasics7 from '@/components/gamification/quiz/QuizBasics7.vue'
import QuizBasics8 from '@/components/gamification/quiz/QuizBasics8.vue'
import QuizBasics9 from '@/components/gamification/quiz/QuizBasics9.vue'
import QuizBasics10 from '@/components/gamification/quiz/QuizBasics10.vue'
import FITBBasic1 from '@/components/gamification/fill-in-the-blanks/FITBBasic1.vue'
import FITBRisk1 from '@/components/gamification/fill-in-the-blanks/FITBRisk1.vue'
import FITBRisk2 from '@/components/gamification/fill-in-the-blanks/FITBRisk2.vue'
import FITBRisk3 from '@/components/gamification/fill-in-the-blanks/FITBRisk3.vue'
import BankTeller1 from '@/components/gamification/scenario/BankTeller1.vue'
import BankTeller2 from '@/components/gamification/scenario/BankTeller2.vue'
import BankTeller3 from '@/components/gamification/scenario/BankTeller3.vue'
import QuizRisk1 from '@/components/gamification/quiz/QuizRisk1.vue'
import Logout from '@/components/RiskyPawsLogout.vue'
import AuthPage from '@/components/AuthPage.vue' 
import Login from '@/components/RiskyPawsLogin.vue'
import BasicsScenario1 from '@/components/gamification/scenario/BasicsScenario1.vue'


const routes = [

  //public
  { path: '/landingpage', component: LandingPage, meta: { isPublic: true } },
  { path: '/login', component: AuthPage, meta: { isPublic: true } },
  { path: '/resetpassword', component: ResetPassword, meta: { isPublic: true } },
  { path: '/loginalt', component: Login, meta: { isPublic:true }},

  //Auth Routes + Onboarding
 
  { path: '/profile', component: UserProfile},
  { path: '/onboarding', component: onboarding},
  { path: '/', component: FinancialDashboard }, 
  { path: '/applayout', component: AppLayout},
  { path: '/logout', component: Logout},


  //Dashboard
  { path: '/dashboard', component: FinancialDashboard },
  { path: '/calendar', component: FinancialCalendar },
  { path: '/gram', component: RiskyGram },
  { path: '/greeting', component: UserGreeting},
  { path: '/trustedcontact', component: TrustedContact},
  { path: '/personal', component: Personal},
  { path: '/chat', component: MeowGPT },
  { path: '/budgetcomingsoon', component: BudgetComingSoon },
  { path: '/tracker', component: FinancialTracker }, 
  { path: '/financialassets', component: FinancialAssets },
  { path: '/networth', component: NetWorth },
  { path: '/holdings', component: Holdings },
  { path: '/tradejournal', component: TradeJournal},
  { path: '/financialdiary', component: FinancialDiary},
  { path: '/subscription', component: SubscriptionTracker},
  { path: '/dividends', component: DivTracker},

  //framework
  { path: '/framework', component: FrameworkDashboard },
  { path: '/risk', component: RiskManagement },
  { path: '/insurance', component: Insurance },
  { path: '/save', component: Save},
  { path: '/kyc', component: KYC},
  { path: '/yield', component: Yield },
  { path: '/planning', component: Planning },
  { path: '/assets', component: AssetAllocation },
  { path: '/wealth', component: WealthManagement },
  { path: '/strategies', component: Strategies },
  { path: '/budget', component: FinancialBudget},
  { path: '/insurancepremiums', component: insurancepremiums},
  { path: '/petinsurance', component: petinsurance},
  { path: '/investorprotections', component: investorprotections},
  { path: '/yieldchasing', component: yields},
  { path: '/compoundinterestcalculator', component: compoundinterest},
  { path: '/coolingoff', component: coolingoff},
  { path: '/riskintro', component: riskintro},
  { path: '/creditestimator', component: CreditEstimator},
  { path: '/creditexplainer', component: CreditExplainer},
  { path: '/creditscorecalculator', component: CreditScoreCalculator},
  { path: '/games/creditloanofficer', component: CreditLoanOfficer},
  { path: '/goalsettinginput', component: GoalSettingInput},
  { path: '/incometaxcalculator', component: IncomeTaxCalculator},
  { path: '/goals', component: GoalsObjectives}, 
  { path: '/homebuyertool', component: HomeBuyerTool},
  { path: '/stocklogogame', component: StockLogoGame},
  { path: '/taxprovinces', component: TaxProvinces},
  { path: '/frameworknew', component: Framework},
  { path: '/lazyportfolios', component: LazyPortfolio },
  { path: '/tradingart', component: TradingArt },
  { path: '/grouprrsp', component: GroupRRSP },
  { path: '/markets', component: Markets},
  { path: '/incometaxes', component: IncomeTaxes},
  { path: '/comprehensiverisk', component: ComprehensiveRisk},
  { path: '/applyingrisk', component: ApplyingRisk},
  { path: '/aml', component: AML},
  { path: '/options', component: PayoffDiagram },
  { path: '/optionsstrategies', component: Options},
  { path: '/kycintro', component: KYCIntro},
  { path: '/contributionroom', component: ContributionRoom},
  { path: '/beta', component: Beta},
  { path: '/alpha', component: Alpha},
  { path: '/findingalpha', component: FindingAlpha},
  { path: '/tipcalculator', component: TipCalculator},
  { path: '/economics', component: EconomicCalendar},
  { path: '/jobcomparison', component: JobComparison},
  { path: '/homebuyingtool', component: HomeBuyingTool},
  { path: '/canadianinvesting', component: CanadianInvesting},
  { path: '/canadaheatmap', component:  CADHeatMap},
  { path: '/usheatmap', component:  USHeatMap},
  { path: '/financialgoals', component: FinancialGoals},
  { path: '/unclaimedproperty', component: UnclaimedProperty},
  { path: '/investmentaccounts', component: InvestmentAccounts},
  { path: '/creditcardyield', component: CreditCardsYield},
  { path: '/estateplanning', component: EstatePlanning},
  { path: '/norbertsgambit', component: Norbert},
  { path: '/zakat', component: Zakat },

  //gamification

  { path: '/games/menu', component: GamesMenu},
  { path: '/games/quiztemplate', component: QuizTemplate},
  { path: '/games/filltemplate', component: FillBlank},
  { path: '/games/matching', component: Matching},
  { path: '/games/scenario', component: Scenario},
  { path: '/games/basics1', component: MatchBasics1},
  { path: '/games/basics2', component: MatchBasics2},
  { path: '/games/basics3', component: MatchBasics3},
  { path: '/games/basics4', component: MatchBasics4},
  { path: '/games/basics5', component: MatchBasics5},
  { path: '/games/basics6', component: MatchBasics6},
  { path: '/games/basics7', component: MatchBasics7},
  { path: '/games/basics8', component: MatchBasics8},
  { path: '/games/basics9', component: MatchBasics9},
  { path: '/games/basics10', component: MatchBasics10},
  { path: '/games/basic1b', component: FITBBasic1},
  { path: '/games/risk1b', component: FITBRisk1},
  { path: '/games/risk2b', component: FITBRisk2},
  { path: '/games/risk3b', component: FITBRisk3},
  { path: '/games/bankteller1', component: BankTeller1},
  { path: '/games/bankteller2', component: BankTeller2},
  { path: '/games/bankteller3', component: BankTeller3},
  { path: '/games/risk1c', component: QuizRisk1},
  { path: '/games/basics1c', component: QuizBasics1},
  { path: '/games/basics2c', component: QuizBasics2},
  { path: '/games/basics3c', component: QuizBasics3},
  { path: '/games/basics4c', component: QuizBasics4},
  { path: '/games/basics5c', component: QuizBasics5},
  { path: '/games/basics6c', component: QuizBasics6},
  { path: '/games/basics7c', component: QuizBasics7},
  { path: '/games/basics8c', component: QuizBasics8},
  { path: '/games/basics9c', component: QuizBasics9},
  { path: '/games/basics10c', component: QuizBasics10},
  { path: '/games/basics1d', component: BasicsScenario1},



  //testing

  { path: '/new', component: NewPage }, 
  { path: '/postit', component: Postit},
  { path: '/test', component: Test},
  { path: '/newtest', component: New }, 

];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to the top of the page on route changes
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const isPublicRoute = to.matched.some(record => record.meta.isPublic);

  if (!isPublicRoute) {
    try {
      await Auth.currentAuthenticatedUser();
      next(); // User is authenticated, proceed to the route
    } catch (error) {
      next('/login'); // User is not authenticated, redirect to login
    }
  } else {
    next(); // It's a public route, so proceed
  }
});

export default router;